import React, { useState } from "react";
import rocketIcon from "./../../assets/rocket.svg";
import clockIcon from "./../../assets/clock.svg";
import staffIcon from "./../../assets/staff.svg";
import ActiveTabBottomDesign from "./ActiveTabBottomDesign";
import SaveStaffHours from "./TabContent/SaveStaffHours";
import PaymentTabContent from "./TabContent/PaymentTabContent";
import ReduceNoShow from "./TabContent/ReduceNoShow";

const TabComponent = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  return (
    <div
      className="tabs-container border-tabsBorderColor shadow-md" id="main-body-container-second"
    >
      <div className="flex flex-col gap-1 mb-4">
        <p className="text-[#71B254] text-3xl font-bold">
          Other areas where you can see savings using CheckinAsyst
        </p>
        <p className="text-[#1A1A1A] text-lg font-medium">
          Answer the below questions to calculate your returns in different areas of operation:
        </p>
      </div>
      <div className="box-second-section"></div>
      <div className="tabs flex w-full box-second-section1">
        <button
          className={`tab-button  rounded-tl-lg ${
            activeTab === 1 ? "active bg-[#9C9C9C]" : "bg-[#FAF9F7]"
          }`}
          onClick={() => handleTabClick(1)}
        >
          <div className="flex flex-col justify-center items-center h-full">
            {/* <img src={rocketIcon} alt="r-icon" className="w-full" height={30} /> */}
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 1 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              2.{" "}
            </p>
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 1 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              Boost Patient Payments
            </p>
          </div>
          {/* {activeTab === 1 && <ActiveTabBottomDesign />} */}
        </button>
        <button
          className={`tab-button  ${activeTab === 2 ? "active bg-[#9C9C9C]" : "bg-[#FAF9F7]"}`}
          onClick={() => handleTabClick(2)}
        >
          <div className="flex flex-col justify-center items-center h-full">
            {/* <img src={clockIcon} alt="r-icon" className="w-full" height={30} /> */}
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 2 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              3.
            </p>
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 2 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              Reduce Patient <br /> No-shows
            </p>
          </div>
          {/* {activeTab === 2 && <ActiveTabBottomDesign />} */}
        </button>
        <button
          className={`tab-button   rounded-tr-lg ${
            activeTab === 3 ? "active bg-[#9C9C9C]" : "bg-[#FAF9F7]"
          }`}
          onClick={() => handleTabClick(3)}
        >
          <div className="flex flex-col justify-center items-center h-full">
            {/* <img src={staffIcon} alt="r-icon" className="w-full" height={30} /> */}
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 3 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              4.
            </p>
            <p
              className={`text-center font-medium text-xl ${
                activeTab === 3 ? "text-white" : "text-secondaryBlack"
              }`}
            >
              Increase Staff Productivity
            </p>
          </div>
          {/* {activeTab === 3 && <ActiveTabBottomDesign />} */}
        </button>
      </div>
      <div className="tab-content" style={{position: "relative", bottom: "130px"}}>
        {activeTab === 1 && <PaymentTabContent />}
        {activeTab === 2 && <ReduceNoShow />}
        {activeTab === 3 && <SaveStaffHours />}
      </div>
    </div>
  );
};

export default TabComponent;
